<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <div v-if="roles.length > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ roles.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Role Name</th>
                                <th>Created Date</th>
                                <th>Updated Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(role, index) in roles" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ role.name }}</td>
                                <td>{{ customCreatedDate(role.created_at) }}</td>
                                <td>{{ customCreatedDate(role.updated_at) }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="roles.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import moment from "moment";

    export default {
        page: {
            title: "Role List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Role List",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Role List",
                        active: true
                    }
                ],
                roles: [],
            };
        },

        mounted() {
            this.getUsers();
        },
        methods: {
            getUsers() {
                http.get("api/role/logged/list").then(response => {
                    if (!response.error) {
                        this.roles = response.data.roles;
                    }
                });
            },
            customCreatedDate(date) {
                return moment(date).format("YYYY-MM-DD, h:mm:ss a");
            },
        },
    };
</script>
